import label from "@/lang/StaticLabels.js";
import { RUNTIME_ENV } from "@/runtimeEnv";
import { EventBus } from "@/plugins/eventBus.js";

// PBASE Navbar  - مدیریت سیستم  -----------------------------------------------
let navItems = [
  {
    title: label.modules.pbase,
    icon: "mdi-map-marker-radius",
    to: false,
  },
  {
    to: "Dashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
  },
  {
    to: "PBASELastLogin",
    label: label.menu.activeSessions,
    metaLabel: label.page.activeSessions,
    icon: "mdi-clock-check-outline",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.dataOperation,
    icon: "pi pi-database",
    active: false,
    subItems: [
      {
        to: "PBASESbu",
        label: label.menu.sbu,
        metaLabel: label.page.manangeSbu,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: null,
        label: label.menu.floatAccount,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: null,
        label: label.menu.personManagement,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PBASEPersonGroup",
            label: label.menu.personGroup,
            metaLabel: label.page.personGroup,
            icon: "mdi-circle-small",
          },
          {
            to: "PBASEPersonList",
            label: label.menu.person,
            metaLabel: label.page.person,
            icon: "mdi-circle-small",
          },
          {
            to: "PBASEPrefix",
            label: label.menu.prefix,
            metaLabel: label.page.prefix,
            icon: "mdi-circle-small",
          },
        ],
      },

      {
        to: "PBASEPosition",
        label: label.menu.position,
        metaLabel: label.page.position,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBASELocation",
        label: label.menu.location,
        metaLabel: label.page.location,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBASEVoucherTemplate",
        label: label.menu.voucherTemplate,
        metaLabel: label.page.voucherTemplate,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBASECurrencyType",
        label: label.menu.currencyType,
        metaLabel: label.page.currencyType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBASECurrencyRate",
        label: label.menu.currencyRate,
        metaLabel: label.page.currencyRate,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBASEBankesAndBranches",
        label: label.menu.banksAndBranches,
        metaLabel: label.page.banksAndBranches,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBASEDocumentTypes",
        label: label.menu.documentTypes,
        metaLabel: label.page.documentTypes,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBASEVehicleTypes",
        label: label.menu.vehicleTypes,
        metaLabel: label.page.vehicleTypes,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBASEUnit",
        label: label.menu.unit,
        metaLabel: label.page.unit,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },

  {
    to: null,
    label: label.menu.manageUsers,
    icon: "pi pi-users",
    active: false,
    subItems: [
      {
        to: "PBASEUsersGroup",
        label: label.menu.usersGroup,
        metaLabel: label.page.usersGroup,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBASERoles",
        label: label.menu.roles,
        metaLabel: label.page.roles,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBASEUserList",
        label: label.menu.addUserAndRoles,
        metaLabel: label.page.usersAndRoles,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.cartable,
    icon: "pi pi-folder-open",
    active: false,
    subItems: [
      {
        to: "PBASECartableConfirmPriority",
        label: label.menu.approvalCartablePriorities,
        metaLabel: label.page.approvalCartablePriorities,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.systemSetting,
    icon: "pi pi-cog",
    active: false,
    subItems: [
      {
        to: "BoardOfDirectors",
        label: label.menu.boardOfDirectors,
        metaLabel: label.page.boardOfDirectors,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBASEBranchList",
        label: label.menu.manageBranches,
        metaLabel: label.page.branches,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBASEFiscalYear",
        label: label.menu.manageFiscalYears,
        metaLabel: label.page.fiscalYears,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },

      {
        to: "PBASESystemSetting",
        label: label.menu.settings,
        metaLabel: label.page.systemSetting,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBASESmsPanelSettings",
        label: label.menu.smsPanelSettings,
        metaLabel: label.page.smsPanelSettings,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PBASESettingTransactions",
        label: label.menu.settingTransactions,
        metaLabel: label.page.settingTransactions,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
];

function setFloatAccountSubItems(floatAccount) {
  const dataOperation = navItems.find(
    (item) => item.label === label.menu.dataOperation,
  );
  if (!dataOperation) return;

  const floatAccountItem = dataOperation.subItems.find(
    (item) => item.label === label.menu.floatAccount,
  );
  if (!floatAccountItem) return;

  floatAccountItem.subItems = [
    {
      to: "PBASEFloatAccountConfig",
      label: label.menu.floatLevels,
      metaLabel: label.page.floatLevels,
      icon: "mdi-circle-small",
    },
    {
      to: "PBASEFloatAccountLevelOne",
      label: floatAccount[0]?.title || "",
      metaLabel: floatAccount[0]?.title || "",
      icon: "mdi-circle-small",
    },
    {
      to: "PBASEFloatAccountLevelTwo",
      label: floatAccount[1]?.title || "",
      metaLabel: floatAccount[1]?.title || "",
      icon: "mdi-circle-small",
    },
    {
      to: "PBASEFloatAccountLevelThree",
      label: floatAccount[2]?.title || "",
      metaLabel: floatAccount[2]?.title || "",
      icon: "mdi-circle-small",
    },
    {
      to: "PBASEFloatAccountLevelFour",
      label: floatAccount[3]?.title || "",
      metaLabel: floatAccount[3]?.title || "",
      icon: "mdi-circle-small",
    },
    {
      to: "PBASEFloatAccountLevelFive",
      label: floatAccount[4]?.title || "",
      metaLabel: floatAccount[4]?.title || "",
      icon: "mdi-circle-small",
    },
  ];
}

export async function loadFloatAccountConfigs() {
  try {
    const lang = JSON.parse(localStorage.getItem("mitaLanguage")) || 1;
    const response = await fetch(
      RUNTIME_ENV.VUE_APP_API_URL + "base/api/v1/DropDown/FloatAccountConfigs",
      {
        method: "GET",
        headers: {
          Authorization: localStorage.mitaToken,
          "Content-Type": "application/json",
          fiscalYearId: localStorage.FiscalYearId,
          branchId: localStorage.BranchId,
          dateType: localStorage.DateType,
          dateTimeFormat: localStorage.DateTimeFormat,
          "Accept-Language": lang === 1 ? "fa-IR" : "en-US",
        },
      },
    );

    if (!response.ok) throw new Error("Failed to fetch data from API");
    const result = await response.json();
    setFloatAccountSubItems(result.data);
  } catch (error) {
    console.error("loadFloatAccountConfigs failed:", error);
  }
}
if (localStorage.mitaToken) {
  loadFloatAccountConfigs();
}

EventBus.$on("floatAccount-change", loadFloatAccountConfigs);

export default navItems;
